module.exports = __webpack_public_path__ + "static/media/checkout-test.431e4d77.png";